import { graphql } from "@/lib/gql/__generated__/gql";

export const INVOICE_SYSTEM_SETTINGS_MUTATION = graphql(/* GraphQL */ `
	mutation InvoiceSystemSettingsUpdate($input: InvoiceSystemSettingsInput!) {
		invoiceSystemSettingsUpdate(input: $input) {
			userErrors
			invoiceSystemSettings {
				hotelID
				id
				registrationStatus
				registrationCode
			}
		}
	}
`);
